import React, { memo } from "react";
import Empty from "_c/Empty";
import { SEARCH_NS as ns } from "@/i18n/ns";
import { Button } from "_c/button";
import { Link } from "react-router-dom";
import * as S from "./index-styled";
import { useSelector } from "react-redux";
import { Selectors } from "@/store/masterSearch/selectors";
import { useSearchUrlGenerator } from "@/hooks/useSearchUrlGenerator";
import { useHighlightedCitiesQuery } from "@/hooks/queries/useHighlightedCitiesQuery";
import QueryRequest from "@/components/QueryRequest";
import type { TFunction } from "i18next";

type tProps = {
  t: TFunction;
  query: tAnyDict;
  params: tAnyDict;
};
const SearchEmptyResults = ({ t, query, params }: tProps) => {
  const hasCoords = useSelector(Selectors.hasCoords);
  const urlGenerator = useSearchUrlGenerator();
  const highlightedCitiesQuery = useHighlightedCitiesQuery();
  const places = highlightedCitiesQuery.data;
  const onCityInputClick = () => {
    const $el = document.querySelector<HTMLInputElement>(
      "#master-search-city-input"
    );
    if ($el) {
      $el.focus();
    }
  };
  return (
    <>
      <Empty
        style={{ marginTop: "25px" }}
        width={200}
        centered
        message={t(`${ns}:empty`)}
      />
      {!hasCoords && (
        <S.NoResultsText
          css={`
            margin-top: 10px;
          `}
        >
          <Button onClick={onCityInputClick} medium greenish>
            {t(`${ns}:no_results_select_city`)}
          </Button>
        </S.NoResultsText>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "25px",
        }}
      >
        <S.NoResultsContainer>
          <QueryRequest query={highlightedCitiesQuery}>
            {places && (
              <>
                {places.map((city) => (
                  <li key={city._id}>
                    <Link
                      to={urlGenerator({
                        query,
                        params: {
                          ...params,
                          loc: city.slug,
                        },
                      })}
                    >
                      {city.name}
                    </Link>
                  </li>
                ))}
              </>
            )}
          </QueryRequest>
        </S.NoResultsContainer>
      </div>
    </>
  );
};

export default memo(SearchEmptyResults);
